import React from 'react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { AlertTriangle, Home } from 'lucide-react'
import { Link, useRouteError, isRouteErrorResponse } from 'react-router-dom'

/**
 * エラーページコンポーネント
 */
export default function ErrorPage(): React.JSX.Element {
    const error = useRouteError()

    let errorMessage: string
    if (isRouteErrorResponse(error)) {
        errorMessage = error.statusText
    } else if (error instanceof Error) {
        errorMessage = error.message
    } else {
        errorMessage = 'Unknown error'
    }

    return (
        <div className="min-h-screen flex items-center justify-center bg-background px-4">
            <Card className="w-full max-w-md">
                <CardHeader className="text-center">
                    <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-destructive/10">
                        <AlertTriangle className="h-8 w-8 text-destructive" />
                    </div>
                    <CardTitle className="text-2xl font-semibold text-foreground">
                        エラーが発生しました
                    </CardTitle>
                </CardHeader>
                <CardContent className="text-center space-y-4">
                    <p className="text-muted-foreground">
                        申し訳ございません。予期しないエラーが発生しました。
                    </p>
                    <p className="text-xs text-muted-foreground font-mono bg-muted p-2 rounded">
                        {errorMessage}
                    </p>
                    <div className="flex justify-center">
                        <Button asChild variant="outline">
                            <Link to="/dashboard">
                                <Home className="mr-2 h-4 w-4" />
                                ホームに戻る
                            </Link>
                        </Button>
                    </div>
                </CardContent>
            </Card>
        </div>
    )
}
